module.exports = __webpack_public_path__ + "img/photo-none.1138ace7.jpg";